/* import __COLOCATED_TEMPLATE__ from './buttons.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();